import { TranslateType } from '../../../../translation/translationContext.types';
import { ExceptionPayload } from '../../chatSocket/hooks/useChatWebsocket/useChatWebsocket.types';
import { CustomExceptions, RecognizedExceptions } from './types/exceptions.type';
import { WsErrorsStrategy } from './types/wsErrorsStrategy.type';
import { WsErrorsStrategiesFactory } from './wsErrorsStrategies/strategies.factory';

export class WsErrorHandler {
  private strategies: Map<RecognizedExceptions, WsErrorsStrategy>;

  constructor(translate: TranslateType) {
    this.strategies = new WsErrorsStrategiesFactory(translate).createStrategies();
  }

  handle(wsException: ExceptionPayload): void {
    const strategy = this.strategies.get(
      wsException.code || CustomExceptions.NON_RECOGNIZED_EXCEPTION,
    );

    if (strategy) {
      strategy.handle(wsException);
    }
  }
}
